// @flow
import React from "react";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../styles/buttonStyles";
import { buttonStyles } from "../../styles/buttonStyles";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  rightMargin: {
    marginRight: "10px"
  }
});

type CancelButtonClassesType = {
  ...ButtonStylesClassesType,
  rightMargin: DictionaryType
};

type CancelButtonPropsType = {
  classes: CancelButtonClassesType,
  onClick: Function,
  title?: string,
  noMargin?: boolean
};

const CancelButton = (props: CancelButtonPropsType): React$Element<*> => (
  <Button
    color="primary"
    className={classNames(
      props.classes.linkBtn,
      !props.noMargin && props.classes.rightMargin
    )}
    onClick={props.onClick}
  >
    {props.title ? props.title : "Cancel"}
  </Button>
);

export default withStyles(styles)(CancelButton);
